__webpack_require__.p = "/dev/bikeshed-details/";